import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 查看开放合利共盈店铺
  static queryMutualBenefitShopList(params) {
    return request({
      url: `mutual/queryMutualBenefitShopList`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 申请绑定
  static applyBindingShop(shopCode, type) {
    return request({
      url: `mutual/applyBindingShop?shopCode=${shopCode}&type=${type}`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: {}
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/ProfitSharing/ProfitSharBind/ProfitSharBindServ.js